import { Injectable } from '@angular/core';

function _window(): any {
    return window;
}

@Injectable()
export class WindowRef {
    get nativeWindow(): any {
        return _window;
    }
}



// WEBPACK FOOTER //
// ./src/app/_common/window-ref/window-ref.ts